import { Component } from "@angular/core";
import { Input } from "@angular/core";
import { Tempo } from "../../../models/usuario/EstatisticasLeitura";

@Component({
  selector: "app-indicador-leitura",
  templateUrl: "./indicador-leitura.component.html",
  styleUrls: ["./indicador-leitura.component.scss"],
})
export class IndicadorLeituraComponent {
  @Input() progresso: number;
  @Input() tempoRestante: Tempo;

  public math = Math;

  public constructor() {}
}
